import React from 'react';
import { Box, Container } from '@mui/material';
import { UserProfile } from '../components/UserProfile';

export const ProfilePage: React.FC = () => {
  return (
    <Box minHeight="100vh" bgcolor="background.default" py={4}>
      <Container maxWidth="lg">
        <UserProfile />
      </Container>
    </Box>
  );
};